import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref} from 'vue';
import PackageInfo from '@/assets/about/PackageInfo';
import vuetify from "@/plugins/vuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientAbout',
  setup(__props) {

const packageInfo: PackageInfo = PackageInfo.getInstance();
const depInfo : Ref<string> = ref('');
function created() {
    depInfo.value = getText(packageInfo.dependencies);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getText(obj: any): string {
    return JSON.stringify(obj)
        .replace(/{/g, '')
        .replace(/}/g, '')
        .replace(/,/g, '\n');
}
created();

return { __sfc: true,packageInfo, depInfo, created, getText, vuetify }
}

})